import ImageGallery from 'react-image-gallery';
import  React, { useState, useEffect } from 'react';

function ImageSlider({ urls }) {
  const [Images, setImages] = useState([]);

  useEffect(() => {
    let images = [];

    if (urls && urls.length > 0) {
      urls.map(item =>
        images.push({
          original: item,
          thumbnail: item
        })
      );
    }
    setImages(images);
  }, [urls]);

  const onScreenChange = fullScreenElement => {
    console.debug('isFullScreen  hjgjh?');
  };

  return (
    <div>
      <ImageGallery
        items={Images}
        autoPlay={true}
        lazyLoad={true}
        disableSwipe={true}
        onScreenChange={onScreenChange}
        showThumbnails={false}
      />
    </div>
  );
}

export default ImageSlider;
